function init() {
    autosize($('[data-textareaResiza]'));
}
export default {
    init,
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/textareaResize.js